/*
 * Collection all general base functionality that needs to be provided/executed on every page
 */

// CONSTANTS
// all viewport names
var BREAKPOINT_NAME_XXL = 'xxl';
var BREAKPOINT_NAME_XL = 'xl';
var BREAKPOINT_NAME_L = 'l';
var BREAKPOINT_NAME_M = 'm';
var BREAKPOINT_NAME_S = 's';
var BREAKPOINT_NAME_XS = 'xs';

// all viewport values
var BREAKPOINT_VALUE_XXL = 1400;
var BREAKPOINT_VALUE_XL = 1160;
var BREAKPOINT_VALUE_L = 992;
var BREAKPOINT_VALUE_M = 720;
var BREAKPOINT_VALUE_S = 576;
var BREAKPOINT_VALUE_XS = 0;

// viewport definitions
var BREAKPOINTS = {};
BREAKPOINTS[BREAKPOINT_NAME_XXL] = BREAKPOINT_VALUE_XXL;
BREAKPOINTS[BREAKPOINT_NAME_XL] = BREAKPOINT_VALUE_XL;
BREAKPOINTS[BREAKPOINT_NAME_L] = BREAKPOINT_VALUE_L;
BREAKPOINTS[BREAKPOINT_NAME_M] = BREAKPOINT_VALUE_M;
BREAKPOINTS[BREAKPOINT_NAME_S] = BREAKPOINT_VALUE_S;
BREAKPOINTS[BREAKPOINT_NAME_XS] = BREAKPOINT_VALUE_XS;

// event name
var EVENT_VIEWPORT_CHANGE = 'event_viewport-change';
var EVENT_RESIZE = 'event_resize';

// EGK Datalayer
// (in case of redefining, also adjust in GTM script functions.php)
var DATALAYER_NAME = 'dataLayer';
window[DATALAYER_NAME] = window[DATALAYER_NAME] || [];

/*
 * RESIZE HANDLING
 * for the time being we use a simple event listener that fires an abstracted event that other components can listen on
 */

/**
 * Get width of current viewport / browser window
 * @returns {number} viewport width
 */
function getViewportWidth() {
  return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
}

/**
 * Get name of current viewport based on breakpooint definition and the current viewport width
 * @returns {string} name of viewport/breakpoint
 */
function getViewportName() {
  var currentViewportWidth = getViewportWidth();

  // eslint-disable-next-line no-unused-vars
  var currentViewportName = Object.entries(BREAKPOINTS).find(function([key, value]) {
    return (currentViewportWidth >= value);
  });

  return currentViewportName[0];
}

/**
 * Dispatches custom event for "resize"
 */
function dispatchEventResize() {
   
  const eventResize = new CustomEvent(EVENT_RESIZE, { detail: { viewportWidth: getViewportWidth() } });
  document.dispatchEvent(eventResize);
}

/**
 * Dispatches custom event for "viewport change"
 * @param {string} viewportName
 */
function dispatchEventViewportChange(viewportName) {
   
  const eventViewportChange = new CustomEvent(EVENT_VIEWPORT_CHANGE, { detail: { viewportName: viewportName } });
  document.dispatchEvent(eventViewportChange);
}

// global references
var timeoutResize = null;
var currentViewportName = null;

/**
 * Provide abstracted "resize" event to all components of the website.
 * This handler provides a custom "resize" and "viewport change" event.
 *
 * To reduce the number of dispatched events, there is a simple debounce handling via timeout
 */
function handleResizeEvent() {
  clearTimeout(timeoutResize);
  timeoutResize = setTimeout(function() {
    // trigger event for "resize"
    dispatchEventResize();

    // trigger event for "viewport change"
    var newViewportName = getViewportName();
    if (currentViewportName !== newViewportName) {
      currentViewportName = newViewportName;

      dispatchEventViewportChange(currentViewportName);
    }
  }, 70);
}

// add abstracted "resize" event
window.addEventListener('resize', handleResizeEvent, { passive: true });

// dispatch initial events after page is loaded
document.addEventListener('DOMContentLoaded', function() {
  // JS is enabled
  document.body.classList.remove('no-js');
  handleResizeEvent();
});

export {
  DATALAYER_NAME,
  EVENT_VIEWPORT_CHANGE,
  EVENT_RESIZE,
  BREAKPOINT_NAME_XXL,
  BREAKPOINT_NAME_XL,
  BREAKPOINT_NAME_L,
  BREAKPOINT_NAME_M,
  BREAKPOINT_NAME_S,
  BREAKPOINT_NAME_XS,
  BREAKPOINT_VALUE_XXL,
  BREAKPOINT_VALUE_XL,
  BREAKPOINT_VALUE_L,
  BREAKPOINT_VALUE_M,
  BREAKPOINT_VALUE_S,
  BREAKPOINT_VALUE_XS,
  getViewportName,
  getViewportWidth,
};
